/** Shared driver KYC document resolution (list, detail modal, print). */

export const DOC_SLOTS = [
  { code: "PAN", label: "PAN", fileKey: "doc_pan", urlKeys: ["doc_pan_url", "doc_pan"] },
  {
    code: "AADHAR_FRONT",
    label: "Aadhaar (front)",
    fileKey: "doc_aadhar_front",
    urlKeys: ["doc_aadhar_front_url", "doc_aadhar_front"],
  },
  {
    code: "AADHAR_BACK",
    label: "Aadhaar (back)",
    fileKey: "doc_aadhar_back",
    urlKeys: ["doc_aadhar_back_url", "doc_aadhar_back"],
  },
  {
    code: "LICENCE_FRONT",
    label: "Driving licence (front)",
    fileKey: "doc_licence_front",
    urlKeys: ["doc_licence_front_url", "doc_licence_front"],
  },
  {
    code: "LICENCE_BACK",
    label: "Driving licence (back)",
    fileKey: "doc_licence_back",
    urlKeys: ["doc_licence_back_url", "doc_licence_back"],
  },
  {
    code: "PF_CERTIFICATE",
    label: "PF certificate",
    fileKey: "doc_pf_certificate",
    urlKeys: ["doc_pf_certificate_url", "doc_pf_certificate"],
  },
];

export function pickUrlFromValue(v) {
  if (v == null) return null;
  if (typeof v === "string" && v.length > 0) return v;
  if (typeof v === "object") {
    if (typeof v.url === "string" && v.url.length > 0) return v.url;
    if (typeof v.file === "string" && v.file.length > 0) return v.file;
    if (typeof v.href === "string" && v.href.length > 0) return v.href;
  }
  return null;
}

export function normalizeDocumentTypeCode(raw) {
  if (raw == null) return "";
  return String(raw)
    .trim()
    .toUpperCase()
    .replace(/-/g, "_");
}

export function legacyKycUrl(driver) {
  if (!driver || typeof driver !== "object") return null;
  return pickUrlFromValue(driver.kyc_doc_url) || pickUrlFromValue(driver.kyc_url);
}

export function getDocUrl(driver, slot) {
  if (!driver || typeof driver !== "object") return null;

  for (const k of slot.urlKeys) {
    const u = pickUrlFromValue(driver[k]);
    if (u) return u;
  }

  const bag = driver.documents;
  if (Array.isArray(bag)) {
    for (const item of bag) {
      const dt = normalizeDocumentTypeCode(item?.document_type);
      if (dt && dt === slot.code) {
        const u = pickUrlFromValue(item);
        if (u) return u;
      }
    }
  } else if (bag && typeof bag === "object") {
    const nestedKeys = [
      slot.code,
      slot.code.toLowerCase(),
      slot.fileKey,
      slot.fileKey.replace(/^doc_/, ""),
    ].filter(Boolean);
    for (const nk of nestedKeys) {
      if (nk in bag) {
        const u = pickUrlFromValue(bag[nk]);
        if (u) return u;
      }
    }
  }

  return null;
}

export function hasUploadedDoc(driver, slot) {
  return Boolean(getDocUrl(driver, slot));
}

export function legacyKycUrlExclusive(driver) {
  const leg = legacyKycUrl(driver);
  if (!leg) return null;
  const slotUrls = new Set(DOC_SLOTS.map((s) => getDocUrl(driver, s)).filter(Boolean));
  return slotUrls.has(leg) ? null : leg;
}

export function docCount(driver) {
  let n = DOC_SLOTS.filter((s) => hasUploadedDoc(driver, s)).length;
  if (legacyKycUrlExclusive(driver)) n += 1;
  return n;
}

export function resolveAssetHref(url) {
  if (!url || typeof url !== "string") return url;
  if (/^https?:\/\//i.test(url)) return url;
  const base =
    typeof process !== "undefined" && process.env.NEXT_PUBLIC_API_URL
      ? String(process.env.NEXT_PUBLIC_API_URL).replace(/\/$/, "")
      : "";
  if (url.startsWith("/") && base) return `${base}${url}`;
  return url;
}

/** Prefer highest `id`; otherwise last item in the array. */
export function pickLatestBankAccount(accounts) {
  if (!Array.isArray(accounts) || accounts.length === 0) return null;
  const withId = accounts.filter((a) => a != null && a.id != null);
  if (withId.length > 0) {
    return [...withId].sort((a, b) => Number(b.id) - Number(a.id))[0];
  }
  return accounts[accounts.length - 1];
}
